import { BRAND } from "../brand";

/**
 * 21ik Platform yönetim paneli (/yonetim) ve firma tarafındaki destek oturumu metinleri (K-023).
 * Panelin görünen adı "21ik Platform": firma menüsündeki "Yönetim" grubuyla karışmasın diye.
 */
export const platform = {
  name: `${BRAND.name} Platform`,
  nav: {
    label: "Platform menüsü",
    overview: "Genel bakış",
    tenants: "Firmalar",
    people: "Kişi bul",
    jobs: "Arka plan işleri",
    audit: "Platform kaydı",
    admins: "Yöneticiler",
    logout: "Çıkış yap",
    skip: "İçeriğe geç",
  },
  login: {
    title: "Yönetim paneline giriş",
    lead: `Yalnız ${BRAND.name} ekibi içindir. Şirket hesabıyla buradan giriş yapılamaz.`,
    email: "E-posta",
    password: "Parola",
    submit: "Giriş yap",
    companyLink: "Şirket hesabınızla mı gireceksiniz?",
    companyLinkCta: "Şirket girişi",
    expired: "Panel oturumunuzun süresi doldu. Yeniden giriş yapın.",
    codeLead: "İki adımlı doğrulama: {email} hesabı için doğrulama uygulamanızdaki kodu girin.",
    code: "Doğrulama kodu",
    codeHint: "6 haneli kod, her 30 saniyede yenilenir.",
    codeSubmit: "Doğrula ve giriş yap",
    codeBack: "Başka hesapla giriş yap",
  },
  common: {
    loading: "Yükleniyor…",
    none: "—",
    retry: "Tekrar dene",
    back: "Geri",
    cancel: "Vazgeç",
    close: "Kapat",
    more: "Daha fazla göster",
    prev: "Önceki",
    next: "Sonraki",
    open: "Aç",
    active: "Aktif",
    suspended: "Askıda",
    disabled: "Devre dışı",
    locked: "Kilitli",
    yes: "Evet",
    no: "Hayır",
    minutesLeft_one: "{count} dk kaldı",
    minutesLeft_other: "{count} dk kaldı",
    ago: "{since} önce",
    agoMinutes: "{count} dk önce",
    agoHours: "{count} sa önce",
    agoDays: "{count} gün önce",
    never: "Hiç",
    page: "{from}–{to} / {total}",
  },
  roles: {
    admin: "Sistem yöneticisi",
    hr_manager: "İK yöneticisi",
    hr_specialist: "İK uzmanı",
    finance: "Finans",
    executive: "Şirket yöneticisi",
    employee: "Çalışan",
    noEmployee: "Çalışan kaydı yok",
  },
  modules: {
    leave: "İzin talepleri",
    expenses: "Masraf bildirimleri",
    advances: "Avans talepleri",
    documents: "Belgeler",
    payslips: "Bordro pusulaları",
    announcements: "Duyurular",
  },
  setup: {
    company: "Şirket bilgileri",
    schedule: "Çalışma düzeni",
    structure: "Şubeler ve birimler",
    employees: "Çalışanlar",
    invitations: "Davetler",
    progress: "{done}/{total}",
  },
  endReasons: {
    ended_by_admin: "Destek ekibi bitirdi",
    ended_from_panel: "Panelden bitirildi",
    platform_logout: "Panelden çıkış yapıldı",
    tenant_suspended: "Şirket askıya alındı",
    revoked_by_tenant: "Şirket destek erişimini kapattı",
    revoked: "Oturum kapatıldı",
    expired: "Süresi doldu",
    active: "Sürüyor",
  },
  overview: {
    title: "Genel bakış",
    lead: "Müşteriler, kullanım ve sistem durumu. Örnek firmalar dahil tüm firmalar sayılır.",
    updated: "Son güncelleme {time}",
    refresh: "Yenile",
    attention: "Dikkat isteyenler",
    attentionEmpty: "Şu an dikkat isteyen bir şey yok.",
    attentionKinds: {
      setup_incomplete: "{name} · kurulum {done}/5 · kayıt {date}",
      silent_tenant: "{name} · 14 günü aşkın süredir kimse girmedi",
      silent_tenant_never: "{name} · henüz kimse giriş yapmadı",
      dead_jobs: "Son 7 günde {count} iş başarısız oldu",
      queue_delay: "Kuyrukta {count} iş bekliyor · en eskisi {since}",
      support_active: "Açık destek oturumu · {name} · bitiş {time}",
      suspended: "{name} · askıda",
    },
    customers: "Müşteriler",
    tenants: "Müşteri firma",
    tenantsValue: "{total} · {active} aktif · {suspended} askıda",
    newTenants: "Yeni kayıt",
    newTenantsValue: "Son 7 gün {d7} · son 30 gün {d30}",
    employees: "Çalışan kaydı",
    employeesHint: "Ayrılanlar hariç",
    accounts: "Kullanıcı hesabı",
    activeUsers: "Aktif kullanıcı",
    activeUsersValue: "7 gün {d7} · 30 gün {d30}",
    activeUsersHint: "Pencerede giriş yapan ya da uygulamayı kullanan hesap; destek oturumları sayılmaz.",
    usage: "Modül kullanımı (son 30 gün)",
    usageModule: "Modül",
    usage30: "Kayıt (30 gün)",
    usageTenants: "Kullanan firma",
    usageTotal: "Toplam",
    recent: "Son kayıt olan firmalar",
    jobs: "Arka plan işleri",
    jobsPending: "Bekleyen",
    jobsRunning: "Çalışıyor",
    jobsDead: "Başarısız",
    jobsDeadValue: "{total} · son 7 gün {d7}",
    jobsOldest: "En eski bekleyen",
    jobsLast: "Son tamamlanan",
    jobsLink: "İşlere git",
    support: "Açık destek oturumları",
    supportEmpty: "Şu an açık destek oturumu yok.",
  },
  tenants: {
    title: "Firmalar",
    lead: "Tüm müşteri firmaları ve kullanım durumları.",
    search: "Firma ara",
    searchPlaceholder: "Ad veya kısa ad",
    status: "Durum",
    statusAll: "Tümü",
    sort: "Sıralama",
    sortCreated: "En yeni kayıt",
    sortName: "Ada göre",
    sortActivity: "Son etkinlik",
    sortEmployees: "Çalışan sayısı",
    caption: "Firmalar",
    colTenant: "Firma",
    colStatus: "Durum",
    colCreated: "Kayıt",
    colEmployees: "Çalışan",
    colAccounts: "Hesap",
    colActive7: "Aktif 7 gün",
    colActivity: "Son etkinlik",
    colSetup: "Kurulum",
    empty: "Bu aramaya uyan firma yok.",
    total_one: "{count} firma",
    total_other: "{count} firma",
  },
  tenant: {
    back: "Firmalar",
    lead: "{slug} · kayıt {date} · {timezone}",
    support: "Firma gözünden gir",
    suspend: "Askıya al",
    reactivate: "Yeniden aç",
    state: "Durum",
    stateStatus: "Hesap durumu",
    stateSupport: `${BRAND.name} destek erişimi`,
    supportOn: "Açık",
    supportOff: "Kapalı",
    supportChanged: "{date} tarihinde değişti",
    lastChange: "Son durum değişikliği",
    lastChangeValue: "{action} · {date} · {admin}",
    counts: "Sayılar",
    employees: "Çalışan kaydı",
    accounts: "Etkin hesap",
    pendingInvitations: "Bekleyen davet",
    activeUsers: "Aktif kullanıcı",
    activeUsersValue: "7 gün {d7} · 30 gün {d30}",
    lastActivity: "Son etkinlik",
    structure: "Şube ve birim",
    structureValue: "{branches} şube · {departments} birim",
    pendingApprovals: "Bekleyen onay adımı",
    storage: "Dosya hacmi",
    roleHolders: "Rol sahipleri",
    roleHoldersLead: "Müşteri irtibatları: yalnız ad ve rol. Çalışan listesi panelde gösterilmez.",
    colName: "Ad",
    colRoles: "Roller",
    colLastLogin: "Son giriş",
    viewAs: "{name} gözünden gir",
    noRoleHolders: "Rolü olan etkin hesap yok.",
    setup: "Kurulum ilerlemesi",
    setupDone: "Tamamlandı",
    setupOpen: "Eksik",
    usage: "Modül kullanımı",
    usage30: "Son 30 gün",
    usageTotal: "Toplam",
    quality: "Veri kalitesi",
    qualityLead: "“Eksikleri göster” kurallarının yalnız sayıları; kişi adı gösterilmez.",
    sessions: "Destek oturumları",
    sessionsEmpty: "Bu firmada henüz destek oturumu açılmadı.",
    colWhen: "Başlangıç",
    colAdmin: `${BRAND.name} çalışanı`,
    colTarget: "Kimin gözünden",
    colReason: "Gerekçe",
    colDuration: "Süre",
    colEnd: "Bitiş",
    durationValue: "{count} dk",
  },
  supportDialog: {
    title: "Firma gözünden gir",
    lead: "{company} firmasındaki bir kişinin ekranını salt okunur görürsünüz.",
    person: "Kimin gözünden",
    personHint: "Rol sahipleri listelenir; çalışanı bulmak için adını yazın (en az 2 harf).",
    personSearch: "Kişi ara",
    personEmpty: "Bu aramaya uyan etkin hesap yok.",
    personRequired: "Bir kişi seçin.",
    reason: "Gerekçe",
    reasonHint: "Ne için baktığınızı yazın (en az 10 karakter). Kişisel veri yazmayın.",
    duration: "Süre",
    durationOption: "{count} dk",
    password: "Parolanız",
    passwordHint: "Güvenlik için parolanızı yeniden girin.",
    info: "Salt okunur: hiçbir kayıt değiştirilemez; dosya içerikleri, bordro ve dışa aktarımlar açılmaz; TC kimlik, IBAN ve kişisel iletişim bilgileri gizli kalır. Oturum firmanın denetim kaydına yazılır ve firmanın İK yöneticisi ile sistem yöneticilerine bildirim gider.",
    submit: "Destek oturumunu başlat",
    activeExists: "Açık bir destek oturumunuz var ({company}). Yenisini başlatmadan önce onu bitirin.",
    endActive: "Açık oturumu bitir",
  },
  statusDialog: {
    suspendTitle: "Firmayı askıya al",
    reactivateTitle: "Firmayı yeniden aç",
    suspendConsequence: "{company} firmasının {accounts} kullanıcısının oturumu hemen kapanır ve kimse giriş yapamaz. Bildirim ve e-postalar durur, davetler kabul edilemez. Veriler silinmez; yeniden açtığınızda her şey kaldığı yerden sürer.",
    reactivateConsequence: "Kullanıcılar yeniden giriş yapabilir. Bu sürede kaçan izin hak edişleri ilk günlük işte yazılır.",
    reason: "Gerekçe",
    reasonHint: "En az 10 karakter. Firmanın denetim kaydına da yazılır.",
    confirm: "Onaylamak için firma adını yazın",
    confirmMismatch: "Firma adı eşleşmiyor.",
    password: "Parolanız",
    suspendSubmit: "Firmayı askıya al",
    reactivateSubmit: "Firmayı yeniden aç",
  },
  people: {
    title: "Kişi bul",
    lead: "Firmalar arası hesap arama. Yalnız tam e-posta adresi ya da cep telefonu numarasıyla bulur; ad veya kısmi arama yoktur.",
    search: "E-posta veya cep telefonu",
    searchPlaceholder: "ad@sirket.com ya da 0532 123 45 67",
    submit: "Ara",
    tooShort: "En az 3 karakter yazın.",
    invalid: "Geçerli bir e-posta adresi ya da cep telefonu numarası yazın.",
    empty: "Bu bilgiyle kayıtlı bir hesap yok. Davet henüz kabul edilmemiş olabilir; firmanın İK ekranından bakın.",
    logged: "Aramalar platform kaydına maskeli yazılır.",
    lastLogin: "Son giriş",
    locked: "Hesap geçici olarak kilitli",
    memberships: "Firmalar",
    membershipActive: "Etkin üyelik",
    membershipDisabled: "Kapalı üyelik",
    viewAs: "Firma gözünden gir",
    openTenant: "Firmayı aç",
    resetHint: "Parola sıfırlama kodunu firmanın İK yöneticisi üretebilir; panel parola ya da e-posta değiştirmez.",
  },
  jobs: {
    title: "Arka plan işleri",
    lead: "E-posta, bildirim ve günlük işler. İş içeriği (payload) gösterilmez; hata metinlerinde e-posta ve telefon maskelenir.",
    tabs: "İş durumu",
    statuses: { dead: "Başarısız", pending: "Bekleyen", running: "Çalışıyor", skipped: "Atlanan", done: "Tamamlanan" },
    kinds: {
      notification_deliver: "Bildirim teslimi",
      email_invitation: "Davet e-postası",
      email_password_reset: "Parola sıfırlama e-postası",
      leave_accrue_tenant: "İzin hak edişi (günlük)",
      maintenance_daily: "Günlük bakım",
    },
    caption: "Arka plan işleri",
    colKind: "Tür",
    colTenant: "Firma",
    colStatus: "Durum",
    colAttempts: "Deneme",
    colTime: "Zaman",
    colError: "Son hata",
    platformJob: "Platform işi",
    retry: "Yeniden dene",
    retried: "İş yeniden kuyruğa alındı.",
    empty: "Bu durumda iş yok.",
  },
  audit: {
    title: "Platform kaydı",
    lead: "Panelde yapılan her işlem: girişler, destek oturumları, askıya alma, kişi aramaları. Kayıtlar değiştirilemez.",
    filter: "İşlem",
    filterAll: "Tümü (destek istekleri hariç)",
    filterLogins: "Girişler",
    filterSupport: "Destek oturumları",
    filterRequests: "Destek oturumundaki istekler",
    filterTenant: "Firma durumu",
    filterSearch: "Kişi aramaları",
    caption: "Platform kaydı",
    colAt: "Zaman",
    colAdmin: "Yönetici",
    colAction: "İşlem",
    colTenant: "Firma",
    colDetail: "Ayrıntı",
    colIp: "IP",
    empty: "Kayıt yok.",
    meta: {
      reason: "Gerekçe: {value}",
      duration: "{value} dk",
      target: "{value} gözünden",
      endReason: "Bitiş: {value}",
      term: "Aranan: {value} ({count} sonuç)",
      request: "{method} {route} → {status}",
      secondFactor: "İki adımlı doğrulamayla",
    },
    failReasons: {
      unknown: "Bilinmeyen hesap",
      password: "Parola hatalı",
      disabled: "Hesap devre dışı",
      locked: "Hesap kilitli",
      totp_invalid: "Doğrulama kodu hatalı",
      totp_reused: "Doğrulama kodu tekrar kullanıldı",
      totp_not_enrolled: "İki adımlı doğrulama açık değil (zorunlu)",
    },
  },
  admins: {
    title: "Yöneticiler",
    lead: "Panel hesapları. Bu sürümde tek rol var; ekleme ve kapatma komut satırından yapılır.",
    cli: "Yeni yönetici eklemek için: pnpm --filter @hik/api platform-admin create --email … --name …",
    caption: "Platform yöneticileri",
    colName: "Ad",
    colEmail: "E-posta",
    colStatus: "Durum",
    colLastLogin: "Son giriş",
    colSupport: "Açık destek oturumu",
    colTwoFactor: "İki adımlı doğrulama",
    twoFactor:
      "İki adımlı doğrulama (TOTP) komut satırıyla açılır: platform-admin totp-enable --email … Üretimde varsayılan olarak zorunludur; açık olmayan yönetici giremez.",
  },
  activeSupport: {
    title: "Açık destek oturumunuz var",
    body: "{company} · {name} gözünden · {left}",
    goApp: "Firma ekranına dön",
    end: "Oturumu bitir",
  },
  /** Firma uygulamasındaki destek şeridi ve ilgili ekranlar. */
  banner: {
    label: "Destek oturumu",
    title: `${BRAND.name} destek oturumu`,
    viewingAs: "{name} olarak görüntülüyorsunuz",
    readOnly: "Salt okunur",
    end: "Oturumu bitir",
    short: "Destek · {name}",
    tabPrefix: "Destek",
  },
  ended: {
    title: "Destek oturumu sona erdi",
    lead: "Bu tarayıcıdaki firma oturumu kapandı.",
    reasons: {
      support_ended: "Oturum bitirildi ya da süresi doldu.",
      support_access_disabled: `Firma ${BRAND.name} destek erişimini kapattı.`,
      tenant_suspended: "Firma askıya alındı.",
      session_expired: "Oturumun süresi doldu.",
    },
    back: "Yönetim paneline dön",
  },
  supportAccess: {
    title: `${BRAND.name} destek erişimi`,
    sectionDescription: `${BRAND.name} destek ekibinin hesabınıza salt okunur bakabilmesi; geçmiş destek oturumları.`,
    lead: `${BRAND.name} destek ekibi, sorunlarınızı incelemek için hesabınıza salt okunur bir destek oturumuyla girebilir. Her oturum kayıt altındadır.`,
    status: "Durum",
    on: "Açık",
    off: "Kapalı",
    changed: "{date} · {name}",
    rules: {
      readOnly: "Destek oturumunda hiçbir kayıt değiştirilemez; bordro, belge ve dosya içerikleri açılamaz, dışa aktarım yapılamaz.",
      masked: "TC kimlik numarası, IBAN ve kişisel iletişim bilgileri gizli kalır.",
      limit: "Her oturum en fazla 60 dakika sürer ve gerekçe zorunludur; kim, ne zaman, kimin gözünden baktı aşağıda ve denetim kaydında görünür.",
      notify: "Oturum başladığında İK yöneticileri ve sistem yöneticileri uygulama içi bildirim alır.",
    },
    turnOff: "Destek erişimini kapat",
    turnOn: "Destek erişimini aç",
    confirmOffTitle: "Destek erişimi kapatılsın mı?",
    confirmOff: `Açık destek oturumları hemen sona erer. ${BRAND.name} destek ekibi siz yeniden açana kadar hesabınızı göremez.`,
    confirmOffSubmit: "Erişimi kapat",
    noChange: "Bu ayarı değiştirme yetkiniz yok; yalnız sistem yöneticisi değiştirebilir.",
    sessions: "Destek oturumları",
    sessionsEmpty: "Henüz destek oturumu açılmadı.",
    caption: "Destek oturumları",
    colWhen: "Tarih",
    colAdmin: `${BRAND.name} çalışanı`,
    colTarget: "Kimin gözünden",
    colReason: "Gerekçe",
    colDuration: "Süre",
    colEnd: "Bitiş",
    auditLink: "Denetim kaydında gör",
  },
  suspendedLogin: `Şirketinizin ${BRAND.name} hesabı askıya alındı. Şirket yöneticinize başvurun.`,
};
